import axios from 'axios'
import { handleError, handleSuccess } from './interceptors'
import { getPath, getRefreshHeader, getAuthHeader, onAccessTokenFetched } from './helpers'
import {history} from "../_history";
import Cookies from 'universal-cookie';

const cookies = new Cookies()

class Service {
	visAlreadyFetchingAccessToken = false

	subscribers = []

	constructor() {
		const service = axios.create({ responseType: 'json' })
		service.defaults.headers.common = getAuthHeader()
		service.interceptors.response.use(handleSuccess.bind(this), handleError.bind(this))
		this.service = service
	}

	refreshToken() {
		if (!this.isAlreadyFetchingAccessToken) {
			return this.post('refresh', {}, getRefreshHeader())
				.then(({ data }) => {
					this.isAlreadyFetchingAccessToken = false
					onAccessTokenFetched.call(this, data.access_token)
					localStorage.setItem('user', JSON.stringify(data))
					this.service.defaults.headers.common.Authorization = `Bearer ${data.access_token}`
					this.subscribers = []
					return true
				})
				.catch((error) => {
					this.logout()
					history.push('/')
					cookies.set('isAuthorization', 'false', {path: '/', domain: 'gtobase.com'})
				})
		}
	}

	logout() {
		delete this.service.defaults.headers.common.Authorization
		localStorage.removeItem('user')
	}

	addSubscriber(callback) {
		this.subscribers.push(callback)
	}



	login(credentials) {
		return this.post('login', credentials).then((res) => {
			const user = res.data
			localStorage.setItem('user', JSON.stringify(user))
			this.service.defaults.headers.common.Authorization = `Bearer ${user.access_token}`

			return user
		})
	}

	googleLogin(id_token) {
		return this.post('google_login_oauth2', id_token, { 'Content-Type': 'application/json' }).then(({ data }) => {
			localStorage.setItem('user', JSON.stringify(data))
			this.service.defaults.headers.common.Authorization = `Bearer ${data.access_token}`

			return data
		})
	}

	facebookLogin(token, headers) {
		return this.post('facebook_login', token, headers).then(({ data }) => {
			localStorage.setItem('user', JSON.stringify(data))
			this.service.defaults.headers.common.Authorization = `Bearer ${data.access_token}`

			return data
		})
	}

	get(path, headers = {}, dispatchAction, responseType = 'json') {
		return this.service
			.request({
				method: 'GET',
				url: getPath(path),
				headers: { ...this.service.defaults.headers.common, ...headers },
				onDownloadProgress: (progressEvent) => {
					const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
					if (dispatchAction) {
						dispatchAction(percentCompleted)
					}
				},
				responseType,
			})
			.then((response) => response)
	}

	patch(path, payload, headers = {}) {
		return this.service
			.request({
				method: 'PATCH',
				url: getPath(path),
				data: payload,
				headers: { ...this.service.defaults.headers.common, ...headers },
			})
			.then((response) => response)
	}

	put(path, payload, headers = {}) {
		return this.service
			.request({
				method: 'PUT',
				url: getPath(path),
				data: payload,
				headers: { ...this.service.defaults.headers.common, ...headers },
			})
			.then((response) => response)
	}

	post(path, payload, headers = {}, dispatchAction = null, signal) {
		return this.service
			.request({
				method: 'POST',
				url: getPath(path),
				data: payload,
				headers: { ...this.service.defaults.headers.common, ...headers },
				onDownloadProgress: (progressEvent) => {
					const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
					if (dispatchAction) {
						dispatchAction(percentCompleted)
					}
				},
				signal,
			})
			.then((response) => response)
	}

	delete(path, payload, headers = {}) {
		return this.service
			.request({
				method: 'DELETE',
				url: getPath(path),
				data: payload,
				headers: { ...this.service.defaults.headers.common, ...headers },
			})
			.then((response) => response)
	}
}

export default new Service()
